import React, { useState, useRef } from "react";
import api from "../Service/api";
import "./EmployeeManagement.css";

export default function EmployeeManagement() {
  const [forms, setForms] = useState([
    {
      name: "",
      address: "",
      contactNumber: "",
      designation: "",
      salary: "",
      salaryType: "MONTHLY",
      idImage: null,
    },
  ]);

  const fileRefs = useRef([]);

  const handleChange = (index, e) => {
    const updatedForms = [...forms];
    updatedForms[index][e.target.name] = e.target.value;
    setForms(updatedForms);
  };

  const handleFile = (index, e) => {
    const updatedForms = [...forms];
    updatedForms[index].idImage = e.target.files[0];
    setForms(updatedForms);
  };

  const addForm = () => {
    setForms([
      ...forms,
      {
        name: "",
        address: "",
        contactNumber: "",
        designation: "",
        salary: "",
        salaryType: "MONTHLY",
        idImage: null,
      },
    ]);
  };

  const removeForm = (index) => {
    setForms(forms.filter((_, i) => i !== index));
  };

  const submit = async () => {
    try {
      const payload = new FormData();

      // remove file from JSON
      const requestData = forms.map(({ idImage, ...rest }) => rest);
      payload.append("request", JSON.stringify(requestData));

      forms.forEach((f) => {
        if (f.idImage) payload.append("IdImage", f.idImage);
      });

      await api.post("/api/employees", payload);

      setForms([
        {
          name: "",
          address: "",
          contactNumber: "",
          designation: "",
          salary: "",
          salaryType: "MONTHLY",
          idImage: null,
        },
      ]);

      fileRefs.current.forEach((ref) => ref && (ref.value = null));

      alert("Employees saved successfully!");
    } catch (err) {
      console.error(err);
      alert("Error saving employees");
    }
  };

  return (
    <div className="container employee-form">
      <h1>👨‍💼 Employee Registration</h1>

      {forms.map((form, index) => (
        <div className="form-card" key={index}>
          <h2>Employee {index + 1}</h2>

          <div className="form-row">
            <input name="name" placeholder="Name" value={form.name} onChange={(e) => handleChange(index, e)} />
            <input name="designation" placeholder="Designation" value={form.designation} onChange={(e) => handleChange(index, e)} />
          </div>

          <div className="form-row">
            <input name="contactNumber" placeholder="Contact Number" value={form.contactNumber} onChange={(e) => handleChange(index, e)} />

            <select name="salaryType" value={form.salaryType} onChange={(e) => handleChange(index, e)}>
              <option value="MONTHLY">Monthly Paid</option>
              <option value="WEEKLY">Weekly Paid</option>
              <option value="DAILY">Daily Paid</option>
            </select>
          </div>

          <div className="form-row">
            <input
              name="salary"
              type="number"
              placeholder={
                form.salaryType === "MONTHLY"
                  ? "Monthly Salary"
                  : form.salaryType === "WEEKLY"
                  ? "Weekly Salary"
                  : "Daily Salary"
              }
              value={form.salary}
              onChange={(e) => handleChange(index, e)}
            />
            <input name="address" placeholder="Address" value={form.address} onChange={(e) => handleChange(index, e)} />
          </div>

          <div className="form-row">
            <input
              type="file"
              ref={(el) => (fileRefs.current[index] = el)}
              onChange={(e) => handleFile(index, e)}
            />
          </div>

          {forms.length > 1 && (
            <div className="form-actions">
              <button className="remove-btn" onClick={() => removeForm(index)}>
                Remove
              </button>
            </div>
          )}
        </div>
      ))}

      <div className="form-actions">
        <button className="add-btn" onClick={addForm}>
          + Add Another Employee
        </button>
        <button className="submit-btn" onClick={submit}>
          Save All
        </button>
      </div>
    </div>
  );
}
